import axios from "axios";
import axiosInstance from "../Api/AxiosInstance";
import { triggerShowBrokenLinkDialog } from "../Services/BrokenLinkDialogHelper";

const API_BASE_URL = `${process.env.REACT_APP_SERVICE_URL}`;

function withProfileId(url: string, profileId?: string | null) {
  if (profileId) {
    return `${url}/${profileId}`;
  }
  return url;
}

export const getProfileDetails = async (token: any, profileId?: string) => {
  try {
    const url = withProfileId(`${API_BASE_URL}/Profile`, profileId);
    const instance = token
      ? axios.create({ headers: { Authorization: `Bearer ${token}` } })
      : axiosInstance;
    const response = await instance.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching Profile Details:", error);
    throw error;
  }
};

// Get certifications (optionally by profileId)
export const getCertificationsDetails = async (
  token: any,
  profileId?: string | null
) => {
  if (!token) return null;
  try {
    const url = withProfileId(`${API_BASE_URL}/Certifications`, profileId);
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Certifications Details:", error);
    throw error;
  }
};

// Get education (optionally by profileId)
export const getEducationDetails = async (
  token: any,
  profileId?: string | null
) => {
  if (!token) return null;
  try {
    const url = withProfileId(`${API_BASE_URL}/Education`, profileId);
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Education Details:", error);
    throw error;
  }
};

// Get LBMC experience (optionally by profileId)
export const getExperienceDetails = async (
  token: any,
  profileId?: string | null
) => {
  if (!token) return null;
  try {
    const url = withProfileId(`${API_BASE_URL}/LBMCExperience`, profileId);
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching LBMCExperience Details:", error);
    throw error;
  }
};

// Get Professional Experience Outside LBMC (optionally by profileId)
export const getProfessionalExperienceOutsideLBMC = async (
  token: any,
  profileId?: string | null
) => {
  if (!token) return null;
  try {
    const url = withProfileId(
      `${API_BASE_URL}/ProfessionalExperienceOutsideLbmc`,
      profileId
    );
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching Professional Experience Outside LBMC:",
      error
    );
    throw error;
  }
};
export const getSkills = async (token: any) => {
  if (!token) return null;
  try {
    const response = await axios.get(`${API_BASE_URL}/Skills`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching Skills Details:", error);
    throw error;
  }
};

export const getProfileId = async (token: any, profileId: string) => {
  if (!token) return null;
  try {
    const response = await axios.get(`${API_BASE_URL}/Profile/${profileId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching Profile ID:", error);
    throw error;
  }
};

export const getProfileIdByUsername = async (token: any, username: string) => {
  if (!token) return null;
  try {
    const instance = token
      ? axios.create({ headers: { Authorization: `Bearer ${token}` } })
      : axiosInstance;
    const response = await instance.get(
      `${API_BASE_URL}/ProfileId/${username}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Profile ID:", error);
    try {
      const anyErr: any = error;
      if (anyErr.response && anyErr.response.status === 500) {
        triggerShowBrokenLinkDialog();
      }
    } catch (e) {
      console.debug("Error while triggering broken link dialog", e);
    }
    throw error;
  }
};

export const getEmployeeType = async (token: any) => {
  if (!token) return null;
  try {
    const response = await axios.get(`${API_BASE_URL}/EmploymentTypes`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching Skills Details:", error);
    throw error;
  }
};


export const searchProfile = async (token: any, searchText: string, topResults : number = 10) => {
  if (!token) return null;
  try {
    const response = await axios.get(`${API_BASE_URL}/SearchProfile?searchText=${searchText}&topResult=${topResults}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error while searching profile", error);
    throw error;
  }
};

export const getRandomProfiles = async (token: any) => {
  if (!token) return null;
  try {
    const response = await axios.get(`${API_BASE_URL}/profiles/RandomProfiles`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
 
    return response.data;
  } catch (error) {
    console.error("Error fetching random profiles", error);
    throw error;
  }
};